import { ColumnsType } from "antd/es/table";
import AntTable from "../../components/table/Table";
import {
    EditOutlined,
    DeleteOutlined
} from "@ant-design/icons";
import { Avatar, Button, Flex, Image, Modal, Space, notification } from "antd";
import { useState } from "react";
import { RewardService } from "../../services/RewardService";
import moment from "moment";
import CreateCategory from "./CreateCategory";

export default function Category() {

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [editRecord, setEditRecord] = useState<object>()
    const [refreshData, setRefreshData] = useState<boolean>(false)

    const [columns] = useState<ColumnsType<any>>([
        {
            title: 'Picture',
            align: 'center',
            dataIndex: 'picture',
            key: 'picture',
            render: (value, record) => {
                return <Image src={value.fullpath}></Image>
            },
        },
        {
            title: 'Id',
            align: 'center',
            dataIndex: 'id',
            key: 'id',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Name (TH)',
            align: 'center',
            dataIndex: 'name_th',
            key: 'name_th',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Name (EN)',
            align: 'center',
            dataIndex: 'name_en',
            key: 'name_en',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Is Public',
            align: 'center',
            dataIndex: 'is_public',
            key: 'is_public',
            render: (value, record) => {
                return value
            },
        },
        {
            title: '',
            align: 'center',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text, record: any) => {
                return (
                    <Flex gap="small" wrap="wrap">
                        <div onClick={() => {
                            setIsModalOpen(true)
                            setEditRecord(record)
                        }} >
                            <Button type="primary" icon={<EditOutlined></EditOutlined>}></Button>
                        </div>
                        <div onClick={() => onDelete(record.id)} >
                            <Button type={'primary'} danger icon={<DeleteOutlined></DeleteOutlined>}></Button>
                        </div>
                    </Flex>
                )
            }
        },

    ])

    const onLoadData = async (params: any = {}) => {
        const payload = {
            ...params,
        }
        const res = await RewardService.getCategories(payload)
        return res
    }

    const onDelete = async (id: number) => {
        const res = await RewardService.deleteCategory(id)

        if (res.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            setRefreshData(p => !p)
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    }



    return (
        <>
            <Modal
                title=""
                open={isModalOpen}
                onOk={() => setIsModalOpen(true)}
                onCancel={() => setIsModalOpen(false)}
                footer={null}>
                <CreateCategory
                    record={editRecord}
                    onFinish={() => {
                        setIsModalOpen(false)
                        setRefreshData(p => !p)
                    }}
                ></CreateCategory>
            </Modal>
            <AntTable
                refresh={refreshData}
                menuOptions={[{
                    label: 'Create Category',
                    key: 'create'
                }]}
                menuClick={(e) => {
                    if (e.key == 'create') {
                        setEditRecord({});
                        setIsModalOpen(true)
                    }

                }}
                search
                title="Manage Category"
                columns={columns}
                onLoadData={onLoadData}
            />
        </>
    )
}
